import styled from 'styled-components';
import { Color } from 'modules/styles/colors';
import { MuiButton } from 'theme/material-ui';

export const FeedbackButton = styled(MuiButton)`
  && {
    background-color: ${Color.white};
    border: solid 1px ${Color.tealOriginal};
  }
`;
